import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAuth from '../reducers/auth.reducer';

export const selectState = createFeatureSelector<fromAuth.State>(
  fromAuth.featureKey
);

export const isAuthenticated = createSelector(selectState, (state) => state.isAuthenticated);
export const getUserSession = createSelector(selectState, (state) => state.userSession);
